import React from "react";
import NavBar from "../components/homePage/navBar";
import CreateWarehouse from "../components/warehouses/CreateWarehouse";

const CreateWarehousePage: React.FC = () => {
  return (
    <div>
      <NavBar />
      <CreateWarehouse />
    </div>
  );
};

export default CreateWarehousePage;
